import { useState, useEffect } from 'react';

export function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem('flowboard-cookies-accepted');
    if (!accepted) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem('flowboard-cookies-accepted', new Date().toISOString());
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[200] bg-card border-t border-default p-4 shadow-surface-lg md:bottom-4 md:left-4 md:right-auto md:max-w-md md:rounded-xl md:border">
      <p className="text-sm text-muted mb-3">
        FlowBoard verwendet nur technisch notwendige Cookies (Session-Cookie für die Anmeldung). 
        Keine Tracking- oder Marketing-Cookies.{' '}
        <a href="/privacy" className="accent hover:underline">Datenschutzerklaerung</a>
      </p>
      <div className="flex gap-2">
        <button onClick={accept} className="px-4 py-2 bg-accent text-white rounded-lg text-sm hover:opacity-90 transition-opacity">
          Verstanden
        </button>
      </div>
    </div>
  );
}
